import ProductType from "./cms/ProductType";
import ShopifyVariant from "./shopify/ShopifyVariant";
import Image from "./shopify/Image";
import { SUBSCRIPTION_TYPES } from "~/utils/shopify";

export default class ProductVariant {
    id?: string;
    title: string;
    displayTitle: string;
    sku?: string;
    price: number;
    itemPrice: number;
    itemSalesPrice?: number;
    sizeTag: string;
    image?: Image;
    productType: ProductType;
    tags: string[];
    availableForSale: boolean;
    parentProductId?: string;
    parentProductTitle?: string;
    perBouquetPrice?: string;

    constructor(productVariant: ShopifyVariant, tags: string[], productType: ProductType, variantSalesPriceText: any) {
        this.id = productVariant.id;
        this.title = productVariant.title ?? "";
        this.sku = productVariant.sku;

        const regex = /\(.*?\)/g;
        this.displayTitle = productVariant.title !== "Default Title" ? productVariant.title?.replace(regex, "") ?? "" : productVariant.product?.title ?? "";
        const match = productVariant.title?.match(regex);
        this.sizeTag = match ? match[0].replace("| Best value!", "") : "";

        this.price = Math.round(productVariant.price?.amount ?? 0);
        const salePrice = productVariant.compareAtPriceV2?.amount ?? 0;
        const price = productVariant.price?.amount ?? 0;
        this.itemPrice = salePrice > 0 ? salePrice : price;
        this.itemSalesPrice = salePrice > 0 ? price : undefined;
        this.image = productVariant.image;
        this.availableForSale = productVariant.availableForSale ?? false;
        this.productType = productType;
        this.tags = tags;
        this.parentProductId = productVariant.product?.id;
        this.parentProductTitle = productVariant.product?.title;

        if (SUBSCRIPTION_TYPES.includes(productType.key) && this.displayTitle) {
            const replaceSize = this.displayTitle.replace("Size", "");
            const key: string = replaceSize.replace(" | ", "_").toLowerCase().trim() + "_per_bouquet";
            this.perBouquetPrice = variantSalesPriceText.find((item: any) => item[key])?.[key];
        }
    }
}